import styled from 'styled-components';
import TableRow from '@material-ui/core/TableRow';

import { IconWrapper as Icon } from '@ro-atoms/Icon/Icon.styles';

export const ValidTo = styled.div`
  font-size: 10px;
`;

export const WarningText = styled.div`
  font-size: 10px;
  font-weight: 500;
`;

export const SpIconWrapper = styled(Icon)`
  position: relative;
  margin-right: 10px;
`;

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 10px;
  pointer-events: all;
`;

export const DbzPicker = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #000;
`;

export const Location = styled.div`
  max-width: 237px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  pointer-events: all;
`;

export const Tooltip = styled.div`
  position: absolute;
  z-index: 999999;
`;

export const PickerBoard = styled.div<{ position?: number }>`
  background: #000;
  color: #fff;
  padding: 3px 10px;
  font-weight: bold;
  font-size: 10px;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  position: fixed;
  top: 20px;
  transform: translate(-50%, 0);
  left: ${props => props.position + '%'};
  opacity: 1;
  &:after {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #000;
    position: absolute;
    top: -5px;
    left: 50%;
    margin-left: -5px;
    content: '';
  }
`;

export const TooltipContent = styled.div`
  background: #fff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.7);
  z-index: 1;
  position: relative;
  -webkit-transform: translate(0, -100%);
  -ms-transform: translate(0, -100%);
  transform: translate(0, -100%);
  left: -50%;
  top: -20px;
  border-radius: 4px;
  color: #fff;
`;

export const Container = styled.div`
  opacity: 1;
  position: absolute;
  min-width: 400px;
  pointer-events: none;
  z-index: 1;
`;

export const CustomTableHeadRow = styled(TableRow)`
  height: auto !important;
  th {
    border-bottom: 1px solid #333d;
    &:last-child {
      padding-right: auto;
    }
  }
`;

export const TooltipName = styled.div`
  white-space: nowrap;
  display: inline-block;
  max-width: 308px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
